'use strict';

(function() {
  angular
    .module('specsguardApp')
    .directive('widgetProjectDocuments', widgetProjectDocuments);

  function widgetProjectDocuments () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/documents/widget-project-documents.tmpl.html',
      controller: 'widgetProjectDocumentsCtrl',
      controllerAs: '$widgetProjectDocumentsCtrl',
      scope: true,
    }
  }

})();
